module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "features address-info sr-info download-info"
  }, [_c('div', {
    staticClass: "columns first-info-container"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "feature-helvetica bottom-feature mt-20 download-files"
  }, [_c('a', {
    staticClass: "button sr-link download-mfi",
    attrs: {
      "href": _vm.current.files[0].url,
      "download": _vm.current.files[0].name
    }
  }, [_vm._m(2), _c('b', [_vm._v("unMiner ")]), _c('i', {
    staticClass: "fa fa-download"
  }), _c('span', {
    staticClass: "size-current mfi"
  }, [_vm._v("- " + _vm._s(_vm.current.files[0].size) + "MB")]), _c('div', {
    staticClass: "here fw-400"
  }, [_vm._v("Latest version")])])]), _c('div', {
    staticClass: "feature-helvetica bottom-feature mt-30"
  }, [_c('span', [_vm._v("If you are a more experienced miner you may want to try  ")]), _c('router-link', {
    staticClass: "info-link",
    attrs: {
      "to": "/wizard"
    }
  }, [_c('span', [_vm._v("our easy configuration wizard 🧙‍♂️ for third party mining apps")]), _c('i', {
    staticClass: "fa fa-external-link ml-5"
  })])], 1)]), _c('div', {
    staticClass: "column is-flex aic jcc"
  }, [_c('div', {
    staticClass: "feature img-miner-container"
  }, [_c('Slider', {
    attrs: {
      "slides": 7,
      "externalDots": true
    }
  }, [_c('img', {
    staticClass: "img-miner slide",
    attrs: {
      "src": '/img/desktop-app/1-' + _vm.mode + '.png?v2'
    }
  }), _c('img', {
    staticClass: "img-miner slide",
    attrs: {
      "src": '/img/desktop-app/2-' + _vm.mode + '.png?v2'
    }
  }), _c('img', {
    staticClass: "img-miner slide",
    attrs: {
      "src": '/img/desktop-app/3-' + _vm.mode + '.png?v2'
    }
  }), _c('img', {
    staticClass: "img-miner slide",
    attrs: {
      "src": '/img/desktop-app/4-' + _vm.mode + '.png?v2'
    }
  }), _c('img', {
    staticClass: "img-miner slide",
    attrs: {
      "src": '/img/desktop-app/5-' + _vm.mode + '.png?v2'
    }
  }), _c('img', {
    staticClass: "img-miner slide",
    attrs: {
      "src": '/img/desktop-app/6-' + _vm.mode + '.png?v2'
    }
  }), _c('img', {
    staticClass: "img-miner slide",
    attrs: {
      "src": '/img/desktop-app/7-' + _vm.mode + '.png?v2'
    }
  })])], 1)])]), _c('div', {
    staticClass: "feature feature-helvetica has-text-left"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, _vm._l((_vm.tiles), function(o) {
    return _c('div', {
      staticClass: "tile is-parent"
    }, [_c('article', {
      staticClass: "tile is-child box"
    }, [_c('p', {
      staticClass: "title is-spaced"
    }, [_vm._v(_vm._s(o.title))]), _c('p', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(o.subtitle))])])])
  }), 0)]), _c('div', {
    staticClass: "feature feature-helvetica has-text-left"
  }, [_c('hr'), _c('div', {
    staticClass: "columns changelog-issues-column"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._m(3), _c('ul', _vm._l((_vm.changelog), function(o) {
    return _c('li', {
      class: {
        'changelog-current': o.current
      }
    }, [_c('div', {
      staticClass: "changelog-version"
    }, [_c('span', [_vm._v(_vm._s(o.version) + " - " + _vm._s(o.buildDate) + "  ")]), (o.current) ? _c('b', [_vm._v("(Current)")]) : _vm._e()]), _c('ul', {
      staticClass: "changelog-detail-list"
    }, _vm._l((o.changeList), function(p) {
      return _c('li', [(p.indexOf('IMPORTANT') > -1) ? [_c('strong', [_vm._v(_vm._s(p))])] : [_c('span', [_vm._v(_vm._s(p))])]], 2)
    }), 0), _vm._l((o.files), function(f) {
      return _c('a', {
        staticClass: "button sr-link is-default changelog-download-version",
        attrs: {
          "href": f.url,
          "download": f.name
        }
      }, [_c('div', {
        staticClass: "here fw-400"
      }, [(f.type === 'Base') ? _c('b', {
        staticClass: "fs-13 ml-4"
      }, [_vm._v("Base ")]) : _c('b', {
        staticClass: "fs-13 ml-4"
      }, [_vm._v("unMiner ")]), _c('span', [_vm._v(_vm._s(f.osDetail) + " ")]), _c('i', {
        staticClass: "fa fa-download"
      }), _c('span', {
        staticClass: "size-current main"
      }, [_vm._v("- " + _vm._s(f.size) + "MB")])])])
    })], 2)
  }), 0)]), _vm._m(4)])]), _vm._m(5), _vm._m(6)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-helvetica top-feature top-feature-margin title-desc"
  }, [_c('span', {
    staticClass: "title text-white-on-dark"
  }, [_vm._v("Earning made ")]), _c('span', {
    staticClass: "title pink"
  }, [_vm._v("easy ")]), _c('span', {
    staticClass: "title text-white-on-dark"
  }, [_vm._v(" with your PC.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-helvetica top-feature"
  }, [_c('span', {
    staticClass: "subtitle"
  }, [_vm._v("Our app utilizes well known mining software under the hood and presents an easy to understand user interface for beginners and new miners!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "here fw-400"
  }, [_c('span', [_vm._v("Win 10 / 11 x64  ")]), _c('i', {
    staticClass: "fa fa-windows"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature-helvetica fs-16 has-text-left mb-10"
  }, [_c('b', [_vm._v("Changelog")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "feature-helvetica fs-16 has-text-left mb-18"
  }, [_c('b', [_vm._v("Having issues when installing / downloading?   ")])]), _c('div', {
    staticClass: "articles"
  }, [_c('a', {
    staticClass: "article-mini",
    attrs: {
      "href": "https://unmineable.com/support/article/how-to-download-the-app-on-google-chrome",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "article-inner"
  }, [_c('div', {
    staticClass: "article-title"
  }, [_c('span', [_vm._v(" Downloading the app on Google Chrome")])]), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])])]), _c('a', {
    staticClass: "article-mini",
    attrs: {
      "href": "https://unmineable.com/support/article/how-to-allow-the-download-on-windows",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "article-inner"
  }, [_c('div', {
    staticClass: "article-title"
  }, [_c('span', [_vm._v("My download is missing on Windows explorer")])]), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])])]), _c('a', {
    staticClass: "article-mini",
    attrs: {
      "href": "https://unmineable.com/support/article/how-to-make-an-exclusion-on-windows-defender",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "article-inner"
  }, [_c('div', {
    staticClass: "article-title"
  }, [_c('span', [_vm._v("Making an exclusion on Windows Defender / Security")])]), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature feature-helvetica has-text-left"
  }, [_c('hr')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "feature feature-helvetica has-text-left"
  }, [_c('hr'), _c('p', {
    staticClass: "smaller-content"
  }, [_vm._v("(*) "), _c('b', {
    staticClass: "w400"
  }, [_vm._v("A \"Base Version\" is provided for miners having issues when downloading (due to browser or antivirus restrictions). You will need to download and point your app to the third party miner files after the installation.")])]), _c('p', {
    staticClass: "smaller-content"
  }, [_vm._v("(*) "), _c('b', {
    staticClass: "w400"
  }, [_vm._v("For transparency, all of the software code can be audited through the option \"Source\" inside \"About & Support\"")])]), _c('p', {
    staticClass: "smaller-content"
  }, [_vm._v("(*) unMiner is only intended to be used with our pools.")]), _c('p', {
    staticClass: "smaller-content"
  }, [_vm._v("(*) unMiner mostly recommended for new miners / beginners, as it doesn't provide enough customability for fine tuning and most functionality is hidden for simplicity. Advanced users should directly download any third party mining software of their preference that support our algorithms and use a custom setup / configuration.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fc2a7fc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Download_Miner.vue
// module id = 379
// module chunks = 1